import { render, staticRenderFns } from "./stationeryEdit.vue?vue&type=template&id=33a82562&scoped=true"
import script from "./stationeryEdit.vue?vue&type=script&lang=js"
export * from "./stationeryEdit.vue?vue&type=script&lang=js"
import style0 from "./stationeryEdit.vue?vue&type=style&index=0&id=33a82562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a82562",
  null
  
)

export default component.exports